<div class="container">
    <app-breadcrumbs [breadcrumbs]="breadScrumbArr"></app-breadcrumbs>


    <div class="product-details-upper pl-md-5 pr-md-5 pl-2 pr-2 ">
        <div class="text-left mb-3">
            <h3 style="color: #35c7c7;
    font-weight: 700;
    text-transform: capitalize;">{{this.productcat?.name}}</h3>
            <h3 style="color: #323232;    margin-bottom: 2px;">{{item?.name}}</h3>

        </div>
        <div class="row  m-auto no-gutters ">
            <div class="col-md-6 col-sm-12 text-center">


                <app-product-galary *ngIf="item" [product]="item"
                ></app-product-galary>

            </div>
            <div class="col-md-6 col-sm-12" style="justify-content: center;">
                <app-product-information *ngIf="item" [product]="item"></app-product-information>
            </div>

            <div class="row mt-5 container-fluid no-gutters products-details-tabs text-center"
                 style=" min-height: 300px;">
                <div class="col-md-12">
                    <div class="">
                        <mat-tab-group>
                            <div class="p-5">
                                <mat-tab i18n-label="@@details" label="Details"
                                         style="background-color: #fff;overflow: hidden">
                                    <div class="pt-4 text-left row " style="overflow: hidden">

                                        <div class="col-md-6 col-sm-12">
                                            <h5 i18n>Specifications & manuals</h5>

                                            <app-product-attr-box [sku]="sku"></app-product-attr-box>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <div *ngIf="description!= '' && description != undefined" >


                                                <h5 class="mt-3 mt-sm-0" i18n="@@product_description">Product
                                                    Description</h5>
                                                <div class="description-box">


                                                    <div *ngIf="description !== ''" [innerHTML]="description">

                                                    </div>
                                                    <div *ngIf="description == '' || description==null"
                                                         i18n="@@no_description_available">
                                                        Product description not available.
                                                    </div>
                                                </div>
                                            </div>

                                        </div>


                                    </div>


                                </mat-tab>
                            </div>

                            <div class="p-5">
                                <mat-tab label="{{'reviews'| translate}}  ({{this.review_count}})" class="p-5">

                                    <div class="p-4 text-left" i18n>
                                        <app-product-reviews (reviews_count)="setReviewsCount($event)" *ngIf="item"
                                                             [product]="item"></app-product-reviews>
                                    </div>
                                </mat-tab>
                            </div>


                        </mat-tab-group>
                    </div>

                </div>

            </div>

        </div>

    </div>


    <div *ngIf="item" class="row-fluid ">
        <!--            <app-related-product [sku]="this.item.sku"></app-related-product>-->
        <app-product-slider i18n-title="@@relate_products_title" [title]="'related_products'|translate"
                            [productSKU]="this.item.sku"
                            [sliderType]="'product_related'" [showInStockProducts]="true"></app-product-slider>

    </div>
    <!--    <div class="container-fluid p-0">-->

    <!--        <app-brands></app-brands>-->
    <!--    </div>-->


    <!-- info tab -->

</div>
